"use client";
import { Minus } from "lucide-react";
import Image, { StaticImageData } from "next/image";
import React from "react";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";

type Props = {
  img: StaticImageData;
  placeName: string;
};

const ImageContainer = ({ img, placeName }: Props) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        "max-lg:overflow-hidden p-10 duration-500 transition-all h-full relative ",
        "lg:hover:basis-1/4 [&>#overlay]:hover:bg-black/40 [&>div>ul]:hover:opacity-100 rtl:[&>div>ul]:hover:right-0 ltr:[&>div>ul]:hover:left-0",
        "max-lg:rounded-2xl max-lg:[&>#overlay]:bg-black/40 max-lg:[&>div>ul]:opacity-100 rtl:max-lg:[&>div>ul]:right-0 ltr:max-lg:[&>div>ul]:left-0"
      )}
    >
      <Image
        src={img}
        alt={placeName}
        fill
        className="object-cover object-[75%_50%]"
      />
      <div
        id="overlay"
        className="absolute inset-0 bg-transparent transition-colors duration-500"
      />
      <div className="text-white relative z-[1]">
        <p className="lg:text-[40px] md:text-3xl text-xl">{placeName}</p>
        <Minus size={64} />
        <ul className="mt-7 sm:mt-10 absolute ltr:-left-20 rtl:-right-20 opacity-0 transition-all duration-500 text-xl md:text-2xl lg:text-3xl space-y-6">
          <li> {t("imageContainer.unitInfo")}</li>
          <li> {t("imageContainer.clientsInfo")}</li>
        </ul>
      </div>
    </div>
  );
};

export default ImageContainer;
